import PageWrapper from '@/components/page/PageWrapper';

let children = [];
const requireModule = require.context('@/router/admin/', true, /.*\.js$/);
requireModule.keys().forEach((fileName) => {
    const module = requireModule(fileName).default;

    if (module) {
        children = [ ...children, ...module ];
    }
});

export default [{
    path: '/',
    redirect: '/dashboard',
    name: 'admin',
    component: PageWrapper,
    meta: {
        auth: true,
    },
    children,
}];
